import { HttpInterceptorFn, HttpXsrfTokenExtractor } from '@angular/common/http';
import { inject } from '@angular/core';

export const xsrfInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.withCredentials) {
    const tokenExtractor = inject(HttpXsrfTokenExtractor);
    const headerName = 'X-CSRFToken';
    const token = tokenExtractor.getToken() as string | null;
    if (token !== null && !req.headers.has(headerName)) {
      req = req.clone({ headers: req.headers.set(headerName, token) });
    }
  }
  return next(req);
};
